import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const VAS_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.VAS_SCALE,
  title: 'Visual Analogue Scale (VAS) - Dolore',
  scoreConfig: {
    scoreKey: 'vas_0_100',
    scoreFields: ['vas_0_100'],
  },
  sections: [
    {
      name: 'vas',
      label: 'Visual Analogue Scale (VAS) - Dolore',
      fields: [
        {
          key: 'vas_0_100',
          label: 'VAS (0–100 mm)',
          type: 'number',
          min: 0,
          max: 100,
          step: 1,
          maxScore: 100,
          valueDescriptions: {
            '0': 'Nessun dolore.',
            '100': 'Dolore massimo immaginabile.',
          },
          description:
            'Valore misurato sulla linea VAS (0 = nessun dolore, 100 = peggiore dolore immaginabile).',
        },
      ],
    },
  ],
  computedFields: [
    // CONVERSIONE AUTOMATICA
    {
      key: 'vas_0_10',
      label: 'VAS convertita (0–10)',
      type: 'number',
      calculation: 'ROUND( vas_0_100 / 10 , 1 )',
      maxScore: 10,
    },
    // INTERPRETAZIONE CLINICA
    {
      key: 'interpretazione',
      label: 'Interpretazione clinica',
      type: 'text',
      calculation: `
        IF(vas_0_100 <= 0, "Assenza di dolore",
          IF(vas_0_100 <= 30, "Dolore lieve",
            IF(vas_0_100 <= 70, "Dolore moderato",
              "Dolore severo"
            )
          )
        )
      `,
      maxScore: 0,
    },
  ],
};
